import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';
import Carousel from 'react-material-ui-carousel';
import CarouselImage from './CarouselImage';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
   '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
      border: 'none',
   },
}));

const PhotoViewerDialog = ({ open, onClose, photos, selectedPhotoIndex, onEditPhoto }) => {
   const [currentIndex, setCurrentIndex] = useState(0);

   useEffect(() => {
      if (open && selectedPhotoIndex >= 0 && selectedPhotoIndex < (photos ? photos.length : 0)) {
         setCurrentIndex(selectedPhotoIndex);
      }
   }, [open, selectedPhotoIndex, photos]);

   return (
      <BootstrapDialog
         onClose={onClose}
         open={open}
         maxWidth="lg"
         PaperProps={{
            style: {
               backgroundColor: 'transparent',
               boxShadow: 'none',
               width: '100%'
            },
         }}
      >
         <DialogContent>
            {photos && photos.length > 0 ?
               <Carousel
                  navButtonsAlwaysVisible={false}
                  navButtonsProps={{ style: { display: 'none' } }}
                  autoPlay={false}
                  animation='slide'
                  index={currentIndex}
                  onChange={(index) => setCurrentIndex(index)}
                  sx={{ textAlign: 'center', justifyContent: 'center' }}
               >
                  {
                     photos.map((photo, index) => (
                        <CarouselImage
                           key={photo.id}
                           photo={photo}
                           shouldLoad={Math.abs(index - currentIndex) <= 1 || (currentIndex === 0 && index === photos.length - 1) || (currentIndex === photos.length - 1 && index === 0)}
                           onNext={() => setCurrentIndex((currentIndex + 1) % photos.length)}
                           onPrev={() => setCurrentIndex((currentIndex - 1 + photos.length) % photos.length)}
                           onClose={onClose}
                           onEdit={onEditPhoto ? () => onEditPhoto(photo) : undefined}
                        />
                     ))
                  }
               </Carousel>
            : ''}
         </DialogContent>
      </BootstrapDialog>
   );
};

PhotoViewerDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    photos: PropTypes.array,
    selectedPhotoIndex: PropTypes.number,
    onEditPhoto: PropTypes.func
};

export default PhotoViewerDialog;
